import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  LinearProgress,
  Chip,
  Container,
  Button
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { School, Person, ArrowBack } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import './CoursePreview.css';
import { useEmbedded } from '../../hooks/useEmbedded';
import { tokens } from '../../theme';
const HeaderPaper = styled(Paper)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
  width: '100%',
}));

const ProgressWrapper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

const CourseHeader = ({
  course,
  progress,
  enrollmentCount,
  userRole,
  activities
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isEmbedded = useEmbedded();

  // Check if we have parent course info in the location state
  const locationState = location.state || {};
  const parentCourseId = locationState.parentCourseId;
  const parentCourseName = locationState.parentCourseName || 'Parent Course';

  // Check if we have parent learning path info in the location state
  const parentLPathId = locationState.parentLPathId;
  const parentLPathName = locationState.parentLPathName || 'Parent Learning Path';

  const showEnrollmentCount = [1, 11, 7].includes(userRole);
  const coverImage = course.cover_picture
    ? `${process.env.PUBLIC_URL}/upload/courses/${course.cover_picture}`
    : `${process.env.PUBLIC_URL}/assets/images/course-default.jpg`;

  const handleBackToParent = () => {
    const pathPrefix = isEmbedded ? '/embed' : '';
    if (parentCourseId) {
      navigate(`${pathPrefix}/learner/course/${parentCourseId}`);
    } else if (parentLPathId) {
      navigate(`${pathPrefix}/learner/lpath/${parentLPathId}`);
    }
  };

  const [expanded, setExpanded] = React.useState(false);
  const stripHtml = (value = '') => {
    if (!value) return '';
    const tmp = document.createElement('div');
    tmp.innerHTML = value;
    return (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim();
  };

  console.log('CourseHeader props:',progress.progress);
  

  return (
    <Box className="full-width-header">
      <HeaderPaper elevation={0} className="header-paper">
        <Box className="header-gradient">
          <Container>
            {(parentCourseId || parentLPathId) && (
              <Box>
                <Button
                  variant="outlined"
                  startIcon={<ArrowBack />}
                  onClick={handleBackToParent}
                  size="small"
                  sx={{
                    color: tokens.color.sidebarActive,
                    borderColor: 'rgba(255,255,255,0.5)',
                    '&:hover': {
                      borderColor: tokens.color.sidebarActive,
                      backgroundColor: 'rgba(255,255,255,0.1)'
                    }
                  }}
                >
                  Back to {parentCourseId ? parentCourseName : parentLPathName}
                </Button>
              </Box>
            )}
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={8}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, flexWrap: 'wrap' }}>
                  <Typography
                    variant="h3"
                    component="h1"
                    className="course-title"
                    fontWeight="bold"
                    sx={{ color: tokens.color.bgPrimary, lineHeight: 1.2 }}
                  >
                    {course.name}
                  </Typography>
                  
                  <Chip
                    label={progress?.progress === 100 ? 'Course · Completed' : 'Course'}
                    size="small"
                    sx={{
                      backgroundColor:
                        progress?.progress === 100
                          ? `${tokens.color.positive}1A`
                          : 'rgba(255, 255, 255, 0.13)',
                      borderRadius: 8,
                      color:
                        progress?.progress === 100
                          ? tokens.color.positive
                          : tokens.color.bgPrimary,
                      fontWeight: 600,
                      height: 24,
                    }}
                  />
                </Box>

                {course.description && (
                  <Box sx={{ mt: 2, maxWidth: '760px', overflow:'auto' }}>
                    <Typography
                      variant="body1"
                      sx={{
                        color: 'rgba(255,255,255,0.82)',
                        display: '-webkit-box',
                        WebkitLineClamp: expanded ? 'unset' : 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        lineHeight: 1.6,
                        '& *': { margin: 0 },
                      }}
                      dangerouslySetInnerHTML={{
                        __html: course.description.replace(/<[^>]*>/g, '')
                      }}
                    />
                    {stripHtml(course.description).length > 140 && (
                      <Button
                        size="small"
                        onClick={() => setExpanded(!expanded)}
                        sx={{ color: tokens.color.bgPrimary, p: 0, minWidth: 'auto', mt: 0.5 }}
                      >
                        {expanded ? 'Show less' : 'Show more'}
                      </Button>
                    )}
                  </Box>
                )}
              </Grid>
              <Grid item xs={12} md={4} className="enrollment-container">
                {showEnrollmentCount && (
                  <Chip
                    icon={<Person />}
                    label={`${enrollmentCount} Enrolled`}
                    variant="outlined"
                    className="enrollment-chip"
                    sx={{
                      width: 'fit-content',
                      maxWidth: '100%',
                      alignSelf: 'flex-start',
                      whiteSpace: 'nowrap',
                    }}
                  />
                )}
              </Grid>
            </Grid>
          </Container>
        </Box>
      </HeaderPaper>
    </Box>
  );
};

export default CourseHeader;